import utils from 'helpers/utils';
import {useServiceApiQuery} from 'stores/hooks/query';

const path = utils.servicePath(import.meta.url);

export function useEntityTimelineList ({entityId, page, pageSize, ...rest}, queryOptions = {}) {
  return useServiceApiQuery(path, 'list', {entityId, page, pageSize, ...rest}, queryOptions);
}
